export enum InvoiceSteps {
    Overview = 0,
    Positions = 1,
    /** Not a step of the mask — the id the action button reports under. */
    Action = 2,
    /** The chain the invoice belongs to (#2160): read only, nothing to fill in. */
    Documents = 3,
}
